import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as productApi from '../../lib/api/product';

const [LIST_PRODUCTS, LIST_PRODUCTS_SUCCESS, LIST_PRODUCTS_FAILURE] =
  createRequestActionTypes('product/LIST_PRODUCTS');
export const listProducts = createAction(
  LIST_PRODUCTS,
  (searchData) => searchData,
);
const listProductsSaga = createRequestSaga(
  LIST_PRODUCTS,
  productApi.getProducts,
);

const UNLOAD_PRODUCTS = 'product/UNLOAD_PRODUCTS';
export const unloadProducts = createAction(UNLOAD_PRODUCTS);

export function* productsSaga() {
  yield takeLatest(LIST_PRODUCTS, listProductsSaga);
}

const initialState = {
  products: null,
  error: null,
};

const products = handleActions(
  {
    [LIST_PRODUCTS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      products: data.list.map((product) => ({
        id: product.productUuid,
        productUuid: product.productUuid,
        itemCd: product.itemCd,
        productNm: product.productNm,
        productLine: product.productLine,
        modelNm: product.modelNm,
        partnerUuid: product.partnerUuid,
        partnerNm: product.partnerNm,
        price: product.price,
        priceConsume: product.priceConsume,
        category: product.category,
        useYn: product.useYn === 'Y' ? true : false,
        crtNm: product.crtNm,
        crtDt: product.crtDt,
        cngNm: product.cngNm,
        cngDt: product.cngDt,
      })),
      error: null,
    }),
    [LIST_PRODUCTS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_PRODUCTS]: () => initialState,
  },
  initialState,
);

export default products;
